import React from 'react';
import '../css/Buttons.css';
import { NavLink, useNavigate } from 'react-router-dom';

const Chip = ({ 
  label, 
  icon: Icon, 
  onClick, 
  to, 
  style, 
  className = '', 
  setIsButtonHovered, 
  disabled = false, // Added disabled prop
  variant = 'filled' // 'filled' (default) or 'outlined'
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (disabled) return; // Prevent click when disabled
    if (to) {
      navigate(to);
    } else if (onClick) {
      onClick();
    }
  };

  const variantClass = variant === 'outlined' ? 'chip-outlined' : 'chip-filled';

  return to ? (
    <NavLink
      to={to}
      className={({ isActive }) => `chip ${variantClass} ${className} ${isActive ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
      style={style}
      onMouseEnter={() => setIsButtonHovered && setIsButtonHovered(true)}
      onMouseLeave={() => setIsButtonHovered && setIsButtonHovered(false)}
    >
      {Icon && <Icon className="chip-icon" />}
      {label}
    </NavLink>
  ) : (
    <button
      className={`chip ${variantClass} hover-button ${className} ${disabled ? 'disabled' : ''}`}
      onClick={handleClick}
      style={style}
      disabled={disabled}
      onMouseEnter={() => setIsButtonHovered && setIsButtonHovered(true)}
      onMouseLeave={() => setIsButtonHovered && setIsButtonHovered(false)}
    >
      {Icon && <Icon className="chip-icon" />}
      {label}
    </button>
  );
};

export default Chip;
